(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CampusDeleteController',CampusDeleteController);

    CampusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campus'];

    function CampusDeleteController($uibModalInstance, entity, Campus) {
        var vm = this;

        vm.campus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
